function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRewards = function SvgRewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "9 9 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 14.25a4.25 4.25 0 1 1 0-8.5 4.25 4.25 0 0 1 0 8.5Z",
    transform: "translate(9 9)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgRewards;